module.exports = __webpack_public_path__ + "img/new-hekaya.4e07fecb.jpg";